import {
	Box,
	Chip,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	MenuItem,
	Select,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { useEffect, useState } from "react";
import { attrGroupLinkedTables } from "components/PimDashboard/data";
import { studioAttrGroupLinkedTables } from "../../StudioAttributeGroups/data";
import { shootSkuImagesAssoc } from "../../CreateShoot/data";
import { AddRounded, DeleteRounded, EditRounded } from "@mui/icons-material";
import AddViewImagesModal from "../AddViewImagesModal/AddViewImagesModal";
import { GlobalState } from "context/GlobalContext";
import { set } from "lodash";
import { use } from "react";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";

const defaultViewImages = ["FRONT_VIEW", "SIDE_VIEW", "BACK_VIEW"];

const ImageBox = ({ data, handleDelete = () => {}, disableButtons = false }) => {
	return (
		<Box sx={{ position: "relative" }}>
			<img
				style={{
					width: `100px`,
					height: `120px`,
					objectFit: "cover",
					objectPosition: "50% 0%",
					borderRadius: 2,
					zIndex: 2,
				}}
				src={data?.url}
			/>
			<Box
				sx={{
					position: "absolute",
					left: "50%",
					top: "58%",
					zIndex: 10,
					display: disableButtons === true ? "none" : "block",
				}}>
				<IconButton
					disabled={disableButtons}
					onClick={() => handleDelete(data)}
					sx={{ background: "#00000038", "&: hover": { background: "#00000083" } }}>
					<DeleteRounded sx={{ color: "#fff" }} />
				</IconButton>
			</Box>
		</Box>
	);
};

const ShootSkuImages = ({
	selectedShoot,
	shootSkus,
	setShootSkus,
	handleAddSkuClick = () => {},
	hideAddSku = false,
	disableEdit = false,
}) => {
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();

	const [addViewImgsModal, setAddViewImgsModal] = useState(false);
	const [viewsEditModal, setViewsEditModal] = useState(false);
	const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);

	const [selectedSku, setSelectedSku] = useState();
	const [selectedImgModalView, setSelectedImgModalView] = useState();
	const [imageViews, setImageViews] = useState([]);
	const [newViewState, setNewViewState] = useState("");
	const [imgToDelState, setImgToDelState] = useState();

	useEffect(() => {
		if (!selectedSku) {
			if (shootSkus?.length) {
				setSelectedSku(shootSkus[0]);
			} else {
				setSelectedSku(null);
			}
			setImageViews([]);
			return;
		}
		let viewsObj = {};
		defaultViewImages.forEach((view) => {
			viewsObj[view] = true;
		});
		selectedSku?.[shootSkuImagesAssoc]?.forEach((img) => {
			viewsObj[img.view] = true;
		});
		setImageViews(Object.keys(viewsObj));
	}, [selectedSku]);

	const handleSkuSelect = (sku) => {
		setSelectedSku(shootSkus?.filter((row) => row?.i_code === sku.i_code)[0]);
	};

	const handleEditViewsCloseModal = () => {
		setViewsEditModal(false);
	};
	const handleDeleteConfirmModalClose = () => {
		setDeleteConfirmModal(false);
	};

	const handleAddImagesClick = (view) => {
		setSelectedImgModalView(view);
		setAddViewImgsModal(true);
	};

	const addNewShootSkuImages = async (images, view) => {
		const handleImagesUpload = async (files, data) => {
			const formData = new FormData();
			for (let i = 0; i < files.length; i++) {
				formData.append(shootSkuImagesAssoc, files[i].file);
			}
			// formData.append("i_code", selectedSku?.i_code);
			// formData.append("shoot_id", selectedShoot[studioAttrGroupLinkedTables.shoot.key]?.shoot_id);
			return await axios
				.post("/api/studio/upload_shoot_sku_images", formData, {
					headers: {
						"content-type": "multipart/form-data",
					},
				})
				.then((res) => {
					return res.data.result;
				});
		};

		const imageUrls = await handleImagesUpload(images, selectedShoot);

		const productImages = imageUrls.map((row, index) => {
			return {
				i_code: selectedSku?.i_code,
				view,
				is_main: false,
				url: row.publicUrl,
				shoot_sku_id: selectedSku?.id,
			};
		});

		try {
			const res = await axios.post("/api/studio/bulk_create_shoot_sku_images_sql", productImages);
			return res.data.result;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
	};

	const handleSaveImagesClick = async (images) => {
		if (!images.length) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: "Please select atleast one image", severity: "error" });
			return;
		}
		try {
			setLoadingOpen(true);
			const finalData = await addNewShootSkuImages(images, selectedImgModalView);
			if (finalData) {
				setSnackBarOpen(true);
				setSelectedSku((prev) => {
					return {
						...prev,
						[shootSkuImagesAssoc]: [
							...prev?.[shootSkuImagesAssoc].filter((row) => row?.view !== selectedImgModalView),
							...finalData,
						],
					};
				});
				setShootSkus((prev) => {
					return prev.map((sku) => {
						if (sku?.i_code === selectedSku?.i_code) {
							return {
								...sku,
								[shootSkuImagesAssoc]: [
									...sku?.[shootSkuImagesAssoc].filter((row) => row?.view !== selectedImgModalView),
									...finalData,
								],
							};
						}
						return sku;
					});
				});
				setSnackBar({
					...snackBar,
					message: "Images added successfully",
					severity: "success",
				});
				setAddViewImgsModal(false);
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
			setLoadingOpen(false);
		}
	};

	const handleEditViewsClick = () => {
		setViewsEditModal(true);
	};
	const handleViewDelete = (view) => {
		if (defaultViewImages.includes(view)) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Default views cannot be removed",
				severity: "error",
			});
			return;
		}
		if (selectedSku?.[shootSkuImagesAssoc]?.filter((row) => row?.view === view)?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please remove images from this view before removing",
				severity: "error",
			});
			return;
		}
		setImageViews((prev) => prev.filter((v) => v !== view));
		setSnackBarOpen(true);
		setSnackBar({
			...snackBar,
			message: "View removed successfully",
			severity: "success",
		});
	};
	const handleSkuImageDeleteClick = (image) => {
		setImgToDelState(image);
		setDeleteConfirmModal(true);
	};
	const handleCancelSkuImageDeleteClick = (image) => {
		setImgToDelState();
		handleDeleteConfirmModalClose();
	};
	const handleSkuImageDelete = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		try {
			await axios.delete(`/api/studio/delete_shoot_sku_image/${imgToDelState.id}`).then((res) => {
				setSelectedSku((prev) => {
					return {
						...prev,
						[shootSkuImagesAssoc]: prev?.[shootSkuImagesAssoc]?.filter((row) => row?.id !== imgToDelState.id),
					};
				});
				setShootSkus((prev) => {
					return prev.map((sku) => {
						if (sku?.i_code === selectedSku?.i_code) {
							return {
								...sku,
								[shootSkuImagesAssoc]: sku?.[shootSkuImagesAssoc]?.filter((row) => row?.id !== imgToDelState.id),
							};
						}
						return sku;
					});
				});
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Image deleted successfully",
					severity: "success",
				});
				handleDeleteConfirmModalClose();
				setImgToDelState();
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
			setLoadingOpen(false);
		}
	};
	return (
		<Box width="99%" display="flex" flexWrap="wrap" columnGap="1%">
			<Box width="100%" justifyContent="space-between" display="flex" alignItems="center" pt={1} pb={1}>
				<Typography variant="h6">Shoot Images</Typography>
				<Button
					variant="contained"
					size="small"
					onClick={handleAddSkuClick}
					sx={{ display: hideAddSku ? "none" : "block" }}
					disabled={disableEdit}>
					Add SKU
				</Button>
			</Box>
			<Box display={"flex"} width={"100%"} minHeight="50vh" justifyContent="space-around" flexWrap="wrap">
				<Box sx={{ width: "20%" }}>
					<Typography variant="h6" color={grey[600]} width="100%">
						SKU
					</Typography>
					<List>
						{shootSkus?.map((row) => {
							return (
								<ListItem disablePadding>
									<ListItemButton
										onClick={() => handleSkuSelect(row)}
										selected={selectedSku?.i_code === row?.i_code}>
										<ListItemText primary={row?.i_code} />
									</ListItemButton>
								</ListItem>
							);
						})}
					</List>
				</Box>

				<Divider flexItem orientation="vertical" />
				<Box width="78%">
					<Box display="flex" alignItems="center" mb={2}>
						<Typography variant="h5" color={grey[600]}>
							Views
						</Typography>
						<IconButton onClick={handleEditViewsClick} disabled={disableEdit || !selectedSku}>
							<EditRounded />
						</IconButton>
					</Box>
					{selectedSku &&
						imageViews?.map((view) => {
							const images = selectedSku?.[shootSkuImagesAssoc]?.filter((row) => row?.view === view) ?? [];

							return (
								<Box>
									<Box width="100%" justifyContent="space-between" display="flex" alignItems="center" pt={1} pb={1}>
										<Typography variant="h6" textTransform="capitalize">
											{view?.split("_").join(" ").toLowerCase()}
										</Typography>
										<Button
											variant="contained"
											size="small"
											startIcon={<AddRounded />}
											onClick={() => handleAddImagesClick(view)}
											disabled={disableEdit}>
											Add Images
										</Button>
									</Box>
									<Box display="flex" columnGap="10px" rowGap={"10px"}>
										{images?.map((row) => (
											<ImageBox
												data={row}
												disableButtons={disableEdit}
												handleDelete={handleSkuImageDeleteClick}
											/>
										))}
									</Box>
									<Divider flexItem width="100%" />
								</Box>
							);
						})}
				</Box>
			</Box>

			{addViewImgsModal && (
				<AddViewImagesModal
					modalOpen={addViewImgsModal}
					setModalOpen={setAddViewImgsModal}
					submitFunction={handleSaveImagesClick}
					view={selectedImgModalView}
				/>
			)}

			<Dialog
				fullWidth
				maxWidth="xs"
				open={deleteConfirmModal}
				onClose={handleDeleteConfirmModalClose}
				component="form"
				keepMounted={false}
				onSubmit={handleSkuImageDelete}>
				<Typography p={2} boxSizing="border-box" variant="h6">
					Are you sure you want to delete this image?
				</Typography>
				<Box pl={2} width="100%" boxSizing="border-box" mb={2} display="flex" justifyContent="center">
					<ImageBox data={imgToDelState} disableButtons={true} />
				</Box>
				<DialogActions>
					<Button variant="outlined" onClick={handleCancelSkuImageDeleteClick}>
						Cancel
					</Button>
					<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
						Confirm Delete
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog fullWidth maxWidth="sm" open={viewsEditModal} onClose={handleEditViewsCloseModal}>
				<Typography width="98%" p={2} boxSizing="border-box" variant="h6">
					Add/Remove Views
				</Typography>
				<Box width="98%" p={2} boxSizing="border-box">
					{imageViews.map((view, index) => (
						// display current views as chips and default chaips are not removable
						<Chip
							key={index}
							label={<Typography textTransform="capitalize">{view?.split("_").join(" ").toLowerCase()}</Typography>}
							onDelete={() => handleViewDelete(view)}
							disabled={defaultViewImages.includes(view)}
							sx={{ mr: 1, mb: 1 }}
						/>
					))}
					{/* textfield with add button to push it to views */}
					<Stack direction="row" spacing={2} alignItems="center" mt={2}>
						<TextField
							label="Add View"
							variant="outlined"
							size="small"
							value={newViewState}
							sx={{ width: "70%" }}
							onChange={(e) => setNewViewState(e.target.value)}
						/>
						<Button
							variant="contained"
							onClick={() => {
								if (newViewState && !imageViews.includes(newViewState.toUpperCase().replace(" ", "_"))) {
									setImageViews((prev) => [...prev, newViewState.toUpperCase().replace(" ", "_")]);
									setNewViewState("");
								} else {
									setSnackBarOpen(true);
									setSnackBar({
										...snackBar,
										message: imageViews.includes(newViewState.toUpperCase().replace(" ", "_"))
											? "View already exists"
											: "Please enter a valid view name",
										severity: "error",
									});
								}
							}}>
							Add
						</Button>
					</Stack>
				</Box>
				<DialogActions>
					<Button variant="outlined" onClick={handleEditViewsCloseModal}>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default ShootSkuImages;
